import { EllipsisText, type TableCellProps } from '@shared/components';
import { type TableHeaderRow } from '@shared/table-generator';

export interface ExamDistributionListItem {
  month: string;
  period: string;
}

export function getHeaderWithExamCenterCodes(examCenterCodes: string[]): TableHeaderRow[] {
  const examCenterColumns = examCenterCodes.map<TableCellProps>((examCenterCode) => ({
    id: `exam-center.${examCenterCode}`,
    children: <EllipsisText variant='body1Semibold'>{examCenterCode}</EllipsisText>,
    width: 100,
    align: 'center',
  }));

  return [
    {
      children: [
        { id: 'no', children: 'No', width: 60, align: 'center', colSpan: 1, rowSpan: 2 },
        {
          id: 'period',
          children: 'รายการตารางสอบ',
          sx: {
            minWidth: '164px',
          },
          rowSpan: 2,
          colSpan: 1,
        },
        {
          id: 'exam-center',
          children: 'รอบสอบ',
          align: 'center',
          sx: { lineHeight: 1 },
          colSpan: examCenterCodes.length,
        },
      ],
    },
    {
      children: examCenterColumns,
    },
  ];
}
